import baseRoute from '../baseRoute';

export type * from './requestModel';
export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/${number | ':jobId'}/jobTracking/table/xlsx`;

export const ROUTE: RouteDefinition = `${baseRoute}/:jobId/jobTracking/table/xlsx`;

export const URL = (jobId: number): RouteDefinition => `${baseRoute}/${jobId}/jobTracking/table/xlsx`;
